/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { getProxyUrl } from '../../utils/image';
import { getMatchUrl } from '../../utils/routes';
import { useTeamLogos } from '../../hooks/team';

const STATES = {
  HOME: 'HOME',
  VISITING: 'VISITING',
};

function TeamForm({ match, homeTeamLogo, visitingTeamLogo }) {
  const [teamLogos] = useTeamLogos();
  const [showTeamForm, setShowTeamForm] = useState(STATES.HOME);
  const { homeTeamName, visitingTeamName, homeTeamForm, visitingTeamForm } =
    match;

  const resultMapping = {
    win: 'V',
    lost: 'F',
    draw: 'O',
  };

  const getBadgeColor = (result) => {
    if (result === 'win') {
      return 'badge--comp-green';
    }
    if (result === 'lost') {
      return 'badge--comp-red';
    }

    return 'badge--comp-orange';
  };

  const handleTabClick = () => {
    setShowTeamForm(
      showTeamForm === STATES.HOME ? STATES.VISITING : STATES.HOME
    );
  };

  const tabClass = (tab) =>
    `tabs__item ${showTeamForm === tab ? 'tabs__item--is-active' : ''}`;
  const tabContainerClass = (tab) =>
    `col-12 col-lg-6 d-lg-block ${showTeamForm !== tab ? 'd-none' : ''}`;

  const renderMatch = (m, isVisitingTeam) => {
    const { homeScore, awayScore, type, opponentId, result } = m;
    const opponentTeam = teamLogos?.find((x) => x.abbrv === opponentId);
    const opponentTeamName = opponentTeam?.name || opponentId;

    const badgeColor = getBadgeColor(result);

    if (!isVisitingTeam) {
      const teamText =
        type === 'home'
          ? `${homeTeamName} - ${opponentTeamName}`
          : `${opponentTeamName} - ${homeTeamName}`;
      return (
        <div className="data-container__row px-2 px-lg-3 py-2 d-flex align-items-center gap-2 gap-lg-3">
          {m?.matchId &&
            m?.configSeasonStartYear &&
            m?.homeTeamName &&
            m?.visitingTeamName && (
              <a
                className="button button--primary-blue order-3 order-lg-0"
                href={getMatchUrl(
                  m.configSeasonStartYear,
                  m.matchId,
                  m?.homeTeamName,
                  m?.visitingTeamName
                )}
              >
                Summering
              </a>
            )}
          <div className="d-flex gap-1 order-2 order-lg-1 ms-auto ms-lg-0">
            <div className="score-result">{homeScore}</div>
            <div className="score-result">{awayScore}</div>
          </div>
          <p className="text-regular fw-bold ms-lg-auto order-1 order-lg-2">
            {teamText}
          </p>
          <div
            className={`badge badge--round ${badgeColor} order-0 order-lg-3`}
          >
            {resultMapping[result]}
          </div>
        </div>
      );
    }

    const teamText2 =
      type === 'home'
        ? `${visitingTeamName} - ${opponentTeamName}`
        : `${opponentTeamName} - ${visitingTeamName}`;

    return (
      <div className="data-container__row px-2 px-lg-3 py-2 d-flex align-items-center gap-2 gap-lg-3">
        {m?.matchId &&
          m?.configSeasonStartYear &&
          m?.homeTeamName &&
          m?.visitingTeamName && (
            <a className="button button--primary-blue order-3" href="/">
              Summering
            </a>
          )}
        <div className="d-flex gap-1 order-2 ms-auto">
          <div className="score-result">{homeScore}</div>
          <div className="score-result">{awayScore}</div>
        </div>
        <p className="text-regular fw-bold order-1">{teamText2}</p>
        <div className={`badge badge--round ${badgeColor} order-0`}>
          {resultMapping[result]}
        </div>
      </div>
    );
  };

  if (visitingTeamForm?.length === 0 && homeTeamForm?.length === 0) {
    return null;
  }

  return (
    <section className="row mt-5">
      <div className="col-12 d-flex px-sm-4 align-items-center mb-2 mb-lg-4">
        <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
          FORM - senaste matcherna
        </h2>
      </div>
      <div className="col-12 d-block d-lg-none">
        <div className="data-container__header data-container__header--with-border p-1">
          <div className="tabs">
            <div className="row">
              <div className="col-6 pe-0">
                <div className={tabClass(STATES.HOME)} onClick={handleTabClick}>
                  {homeTeamName}
                </div>
              </div>
              <div id="tab2" className="col-6 ps-0">
                <div
                  className={tabClass(STATES.VISITING)}
                  onClick={handleTabClick}
                >
                  {visitingTeamName}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={tabContainerClass(STATES.HOME)}>
        <div className="data-container data-container--attached-on-mobile">
          <div className="data-container__row data-container__header text-center heading-h5 d-none d-lg-flex align-items-center justify-content-center gap-2 py-2">
            <img height="35" src={getProxyUrl(homeTeamLogo, 50, 50)} alt="" />
            {homeTeamName}
          </div>
          {homeTeamForm
            ?.slice(0, 5)
            .map((formMatch) => renderMatch(formMatch, false))}
        </div>
      </div>
      <div className={tabContainerClass(STATES.VISITING)}>
        <div className="data-container data-container--attached-on-mobile">
          <div className="data-container__row data-container__header text-center heading-h5 d-none d-lg-flex align-items-center justify-content-center gap-2 py-2">
            <img
              height="35"
              src={getProxyUrl(visitingTeamLogo, 50, 50)}
              alt=""
            />
            {visitingTeamName}
          </div>
          {visitingTeamForm
            ?.slice(0, 5)
            .map((formMatch) => renderMatch(formMatch, true))}
        </div>
      </div>
    </section>
  );
}

TeamForm.propTypes = {
  match: PropTypes.shape({
    homeTeamName: PropTypes.string.isRequired,
    visitingTeamName: PropTypes.string.isRequired,
    homeTeamForm: PropTypes.any.isRequired,
    visitingTeamForm: PropTypes.any.isRequired,
  }).isRequired,
  homeTeamLogo: PropTypes.string.isRequired,
  visitingTeamLogo: PropTypes.string.isRequired,
};

export default TeamForm;
